import { render } from "./MostPurchasedCategories.vue?vue&type=template&id=7e71535e&scoped=true"
import script from "./MostPurchasedCategories.vue?vue&type=script&lang=js"
export * from "./MostPurchasedCategories.vue?vue&type=script&lang=js"

import "./MostPurchasedCategories.vue?vue&type=style&index=0&id=7e71535e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e71535e"]])

export default __exports__